import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/shadcn/utils';

const subheadingVariants = cva('scroll-m-20 tracking-tight text-primary-700', {
  variants: {
    variant: {
      h4: 'text-xl font-medium',
      h5: 'text-base font-medium',
      h6: 'text-sm font-medium',
    },
  },
  defaultVariants: {
    variant: 'h4',
  },
});

export const Subheading = ({
  className,
  variant,
  ...props
}: React.ComponentProps<'h4'> & VariantProps<typeof subheadingVariants>) => {
  const Comp = variant ?? 'h4';

  return (
    <Comp
      className={cn(subheadingVariants({ variant, className }))}
      {...props}
    />
  );
};
